// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"fa8a73f1","93":"cb34a808","153":"04207b23","191":"4859f410","211":"ce51951a","347":"29c604d5","545":"c2fb4261","629":"fb148161","891":"e9fa9317","943":"34b86815","949":"171e77ce"}[chunkId] + ".chunk.js";
};